module.exports = __webpack_public_path__ + "static/media/hide-report.8d68ff5d.svg";